export default "__VITE_ASSET__x82bpbTa__"